import i18n from '@assets/i18n/config';

export const TRADING_PROCESS_LIST = [
  {
    value: 'NO_AUTOMATION',
    name: i18n.t('client:tradingProcessItems.NO_AUTOMATION'),
  },
  {
    value: 'PORTFOLIO_OPTIMIZER',
    name: i18n.t('client:tradingProcessItems.PORTFOLIO_OPTIMIZER'),
  },
];
